var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceHosting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 150 150",
    fill: "#025add",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m131.755 112.057a1 1 0 0 1 -1-1v-76.927a4.3 4.3 0 0 0 -4.3-4.3h-102.918a4.3 4.3 0 0 0 -4.295 4.3v76.927a1 1 0 0 1 -2 0v-76.927a6.3 6.3 0 0 1 6.295-6.3h102.923a6.3 6.3 0 0 1 6.3 6.3v76.927a1 1 0 0 1 -1.005 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m126.181 106.484h-102.366a1 1 0 0 1 -1-1v-71.076a1 1 0 0 1 1-1h102.366a1 1 0 0 1 1 1v71.076a1 1 0 0 1 -1 1zm-101.366-2h100.366v-69.076h-100.366z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m126.181 47.083h-102.366a1 1 0 1 1 0-2h102.366a1 1 0 1 1 0 2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m131.665 122.165h-113.33a8.344 8.344 0 0 1 -8.335-8.335v-2.776a1 1 0 0 1 1-1h52.268a1 1 0 0 1 .9.564l1.75 3.605h18.165l1.75-3.605a1 1 0 0 1 .9-.564h52.267a1 1 0 0 1 1 1v2.776a8.344 8.344 0 0 1 -8.335 8.335zm-119.665-10.111v1.776a6.342 6.342 0 0 0 6.335 6.335h113.33a6.342 6.342 0 0 0 6.335-6.335v-1.776h-50.642l-1.75 3.606a1 1 0 0 1 -.9.563h-19.417a1 1 0 0 1 -.9-.563l-1.75-3.606z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m33.214 41.246h-1.891a1 1 0 0 1 0-2h1.891a1 1 0 0 1 0 2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m41.153 41.246h-1.89a1 1 0 0 1 0-2h1.89a1 1 0 0 1 0 2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m49.094 41.246h-1.894a1 1 0 0 1 0-2h1.891a1 1 0 0 1 0 2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m55.792 47.083a1 1 0 0 1 -1-1v-11.675a1 1 0 0 1 2 0v11.675a1 1 0 0 1 -1 1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m118 75.167h-86a1 1 0 0 1 -1-1v-17.834a1 1 0 0 1 1-1h86a1 1 0 0 1 1 1v17.834a1 1 0 0 1 -1 1zm-85-2h84v-15.834h-84z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m118 75.167h-23.5a1 1 0 0 1 -1-1v-17.834a1 1 0 0 1 1-1h23.5a1 1 0 0 1 1 1v17.834a1 1 0 0 1 -1 1zm-22.5-2h21.5v-15.834h-21.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m105.006 68.588a4.582 4.582 0 1 1 3.241-7.822 4.581 4.581 0 0 1 -3.241 7.822zm0-7.163a2.582 2.582 0 1 0 1.826.755 2.578 2.578 0 0 0 -1.825-.755z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m111.075 71.076a.993.993 0 0 1 -.707-.293l-3.547-3.547a1 1 0 1 1 1.414-1.414l3.547 3.547a1 1 0 0 1 -.707 1.707z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m117.391 83.625h-84.791a1 1 0 1 1 0-2h84.786a1 1 0 1 1 0 2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m117.391 91.625h-84.791a1 1 0 1 1 0-2h84.786a1 1 0 1 1 0 2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m117.391 99.625h-84.791a1 1 0 1 1 0-2h84.786a1 1 0 1 1 0 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceHosting);
export default __webpack_public_path__ + "static/media/service-hosting.0c2c84682107231bd51538541d816d8f.svg";
export { ForwardRef as ReactComponent };